module["exports"] = [
  "长",
  "上",
  "南",
  "西",
  "北",
  "诸",
  "宁",
  "珠",
  "武",
  "衡",
  "成",
  "福",
  "厦",
  "贵",
  "吉",
  "海",
  "太",
  "济",
  "安",
  "吉",
  "包"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/city_prefix.js
// module id = 1242
// module chunks = 0